import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import Multiselect from "multiselect-react-dropdown";
import { useSelector, useDispatch } from "react-redux";
import {
  DDTopic,
  DDSubTopic,
  DDLearningOC,
  DDSubLearningOC,
} from "../../ReusableComponents/MultiselectQBDropdowns";
import {
  QuestionLevel,
  BloomTaxonomy,
} from "../../ReusableComponents/QBDropdowns";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import notify from "../../ReusableComponents/ToastifyAlerts";
import Loading from "../../Student/Reusablecomponents/Loading";
import { useNavigate } from "react-router-dom";
import Scenario from "./MathScenario/ScenarioList";
import DirectQuestions from "./MathsDirectQuestions/DirectQuestions";
import InputBasedQuestions from "./MathsIBQuestions/IBQuestions";
import { useLocation } from "react-router-dom";
// import Rmaterial from "./Remediation";
import { FQData } from "../../Redux/Reducers/QBAdmin/FilterQDeatails";
const QBLOFilters = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const ScrollRef = useRef(null);
  const ChapterRef = useRef();
  const GradeRef = useRef();
  const StatusRef = useRef();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const FQuestionDetails = useSelector((state) => state.FQDetails.FQDetails);
  const PagnatioNumber = useSelector((state) => state.PaginationNo);
  const PNumber =
    PagnatioNumber?.Location === location.pathname &&
    PagnatioNumber?.PageNumber;

  const [FiltersList, SetFiltersList] = useState();
  const [FilterScenarioList, SetFilterScenarioList] = useState();
  const [FilterQuestionList, SetFilterQuestionList] = useState();
  const [FSQLParams, SetFSQLParams] = useState({
    Row: "",
    Rowindex: JSON.parse(localStorage.getItem("Rowindex"))?.SIndex || "",
  });
  const [INBFQList, SetINBFQList] = useState();

  const [CurrentPage, SetCurrentPage] = useState(PNumber || 1);

  const [ChapterOptions, SetChapterOptions] = useState([]);
  const [GradeOptions, SetGradeOptions] = useState([]);
  const [QLevel, SetQLevel] = useState(
    JSON.parse(localStorage.getItem("FSelected"))?.QLevel || ""
  );
  const [BTaxonomy, SetBTaxonomy] = useState(
    JSON.parse(localStorage.getItem("FSelected"))?.BTaxonomy || ""
  );
  // const [COState, SetCOState] = useState();
  // const [RContent, SetRContent] = useState(false);
  // const GetFiltervalues = JSON.parse(localStorage.getItem("FSelected"));
  const [Filters, SetFilters] = useState({
    Topic: [],
    SubTopic:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.SubTopic || [],
    LOC: JSON.parse(localStorage.getItem("FSelected"))?.Filters?.LOC || [],
    SubLOC:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.SubLOC || [],
    Chapter:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Chapter || [],
    Grade: JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Grade || [],
    Status:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.Status || [],
    COState:
      JSON.parse(localStorage.getItem("FSelected"))?.Filters?.COState || 0,
  });
  const [PreSelectedFilters, SetPreSelectedFilters] = useState({
    Chapter: [],
    Grade: [],
  });

  const [Load, SetLoad] = useState(false);
  const [NSBased, SetNSBased] = useState(
    localStorage.getItem("FINQSNS") || "1"
  );
  useImperativeHandle(ref, () => ({ ClearAllSTates }));

  const CODropdown = [
    { display: "Cloned", value: 1 },
    { display: "Original", value: 0 },
  ];
  const GetCGMultiselect = async (LOC) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/QuestionBankByLO/GetChapterAndGradeByLO?LO=${LOC}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {

        const ChapterOp = [];
        const GradeOp = [];
        res.data.map((item) => {
          if (
            !ChapterOp.some((chapter) => chapter.value === item.chapterLovId)
          ) {
            ChapterOp.push({
              name: item.chapterName,
              value: item.chapterLovId,
            });
          }
          if (!GradeOp.some((grade) => grade.value === item.gradeLovId)) {
            GradeOp.push({ name: item.gradeName, value: item.gradeLovId });
          }
        });
        SetChapterOptions(ChapterOp);
        SetGradeOptions(GradeOp);
          SetPreSelectedFilters((prev) => ({
            ...prev,
            Chapter:  ChapterOp,
          }));
          SetFilters((prev) => ({
            ...prev,
            Chapter: ChapterOp?.map((c) => (c.value)),
          }));
          SetPreSelectedFilters((prev) => ({
            ...prev,
            Grade: GradeOp
          }));
          SetFilters((prev) => ({
            ...prev,
            Grade:GradeOp?.map((c) => (c.value))
          }));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (!FiltersList && Filters?.Topic?.length > 0) {
      GetFiltersList();
    }
  }, [NSBased, Filters?.Topic]);

  const StoreFilters = (e, r, Name) => {
    if (Name === "LOC") {
      const LOCValues = e.map((val) => val?.value).join(",");
      if (LOCValues?.length > 0) {
        GetCGMultiselect(LOCValues);
      } else {
        ChapterRef.current.resetSelectedValues();
        GradeRef.current.resetSelectedValues();
        SetChapterOptions([]);
        SetGradeOptions([]);
        SetPreSelectedFilters((prev) => ({ ...prev, Grade: [], Chapter: [] }))
        SetFilters((prev) => ({ ...prev, Grade: [], Chapter: [] }));
      }
    }
    if (Name === "Status") {
      if (Filters[Name].includes(r)) {
        SetFilters({
          ...Filters,
          [Name]: Filters[Name].filter((item) => item !== r),
        });
      } else {
        SetFilters({ ...Filters, [Name]: [...Filters[Name], r] });
      }
    } else {
      if (Filters[Name].includes(r.value)) {
        SetFilters({
          ...Filters,
          [Name]: Filters[Name].filter((item) => item !== r.value),
        });
      } else {
        SetFilters({ ...Filters, [Name]: [...Filters[Name], r.value] });
      }
    }
  };
  const StoreStartValue = (e) => {
    SetFilters({ ...Filters, Topic: e });
  };

  const CLearvalueremove = (Name) => {
    if (FiltersList) {
      SetChapterOptions([]);
      SetGradeOptions([]);
      SetPreSelectedFilters({ Chapter: [], Grade: [] });
      switch (Name) {
        case "Topic":
          SetFilters({
            ...Filters,
            SubTopic: [],
            LOC: [],
            SubLOC: [],
            Chapter: [],
            Grade: [],
          });
          break;
        case "SubTopic":
          SetFilters({
            ...Filters,
            LOC: [],
            SubLOC: [],
            Chapter: [],
            Grade: [],
          });
          break;
        case "LOC":
          SetFilters({ ...Filters, SubLOC: [], Chapter: [], Grade: [] });
          break;
      }
    }
  };

  // Below is filters list

  const GetFiltersList = async () => {
    const data = {
      Filters: Filters,
      QLevel: QLevel,
      BTaxonomy: BTaxonomy,
    };

    localStorage.setItem("FSelected", JSON.stringify(data));
    SetFilterScenarioList();
    SetFilterQuestionList();
    SetLoad((prev) => !prev);
    if (Filters?.Topic?.length > 0) {
      await axios
        .get(
          process.env.REACT_APP_API_BASE_URL +
          `/QuestionBankByLO/GetQuestionBankByFilter?TopicId=${Filters?.Topic?.join(",") || 0
          }&SubTopicId=${Filters?.SubTopic?.join(",") || 0}&LO=${Filters?.LOC?.join(",") || 0
          }&IsScenario=${props.TType === "INQ" ? NSBased : 0}
            &SubLO=${Filters?.SubLOC?.join(",") || 0}&ChapterId=${Filters?.Chapter?.join(",") || 0
          }&GradeId=${Filters?.Grade?.join(",") || 0}&QLevel=${QLevel || 0
          }&Blooms=${BTaxonomy || 0}&IsUsed=${Filters?.Status?.join(",") || 0
          }&IsClone=${Filters?.COState || 0}&QBCategoryType=${props.TType}`,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          if (res.data[0]?.topicName) {
            SetFiltersList(res.data);
          } else {
            SetFiltersList(process.env.REACT_APP_NODATAFOUND);
          }
          SetLoad((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      SetFiltersList();
      notify("Topic is mandatory", "warning");
    }
  };

  const FiltersListColumns = [
    { name: "Topic", selector: "topicName", sortable: true },
    { name: "Sub Topic", selector: "subTopicName", sortable: true },
    { name: "Learning Outcome", selector: "loName", sortable: true },
    { name: "Sub Learning Outcome", selector: "subLOName", sortable: true },
    { name: "Chapter", selector: "chapterName", sortable: true },
    { name: "Grade", selector: "gradeName", sortable: true },
    {
      name: "Add/ View",
      sortable: true,
      cell: (row, Rindex) => (
        <div style={{ display: "flex", gap: "3px" }}>
          {props.TType !== "DQ" && NSBased !== "2" && (
            <>
              {" "}
              <div
                className="LinkStyles"
                onClick={() => {
                  FSList(row, Rindex);
                }}
              >
                Scenario ({row.sCount}){" "}
              </div>{" "}
              |
            </>
          )}
          <div
            className={
              (props.TType === "DQ" || NSBased === "2") && "LinkStyles"
            }
            onClick={() => {
              FQList(row, Rindex);
            }}
          >
            {" "}
            Question ({row.qCount}){" "}
          </div>{" "}
          |
          <div
            className="LinkStyles"
            onClick={() => {
              HandelRemidation(row, Rindex);
            }}
          >
            {" "}
            Remedition ({row.remediationCount})
          </div>{" "}
        </div>
      ),
    },
  ];
  // Above is filters list

  // Below is Scenario list
  const FiltersScenarioList = async (Row, QType) => {
    SetFilterScenarioList();
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetScenarioByLOs?SubjectId=${items?.subjectId}&LOId=${Row.loid}&SubLOId=${Row.subLOId}&ChapterId=${Row.chapterId}&GradeId=${Row.gradeId}&QLevelId=${Row.qLevel}&BloomsId=${Row.bloomsId}&IsCloned=${Row.isCloned}&QBCategoryType=${QType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data?.[0]?.scenarioID) {
          SetFilterScenarioList(res.data);
          setTimeout(() => {
            window.scrollTo({
              top: ScrollRef.current.scrollHeight + 200,
              behavior: "smooth",
            });
          }, 500);
        } else {
          SetFilterScenarioList(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const FSList = (Row, Rindex) => {
    dispatch(FQData({ FQDetails: Row }));
    SetFSQLParams({ Row: Row, Rowindex: Rindex });
    const SelectRow = { SIndex: Rindex, CPage: CurrentPage };
    localStorage.setItem("Rowindex", JSON.stringify(SelectRow));
    if (props.TType === "SCQ") {
      FiltersScenarioList(Row, "SCQ");
    } else if (props.TType === "INQ" && NSBased === "1") {
      FiltersScenarioList(Row, "SCDISQ");
    }
  };
  // Above is Scenario List

  // Below is Questions list
  const FiltersQuestionList = async (Row, Qtype) => {
    SetFilterQuestionList();
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/QuestionBank/GetQuestionsByLOs?SubjectId=${items?.subjectId}&LOId=${Row.loid}&SubLOId=${Row.subLOId}&ChapterId=${Row.chapterId}&GradeId=${Row.gradeId}&QLevelId=${Row.qLevel}&BloomsId=${Row.bloomsId}&IsCloned=${Row.isCloned}&QBCategoryType=${Qtype}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data?.[0]?.questionID) {
          SetFilterQuestionList(res.data);
          setTimeout(() => {
            window.scrollTo({
              top: ScrollRef.current.scrollHeight + 200,
              behavior: "smooth",
            });
          }, 500);
        } else {
          SetFilterQuestionList(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const FQList = (Row, Rindex) => {
    SetFSQLParams({ Row: Row, Rowindex: Rindex });
    const SelectRow = {
      SIndex: Rindex,
      CPage: CurrentPage,
    };
    dispatch(FQData({ FQDetails: Row }));
    localStorage.setItem("Rowindex", JSON.stringify(SelectRow));
    if (props.TType === "DQ") {
      FiltersQuestionList(Row, "NONSCQ");
    } else if (props.TType === "INQ" && NSBased === "2") {
      FiltersQuestionList(Row, "NONSCDISQ");
    }
  };
  // Above is Questions list

  const HandelRemidation = (Row, Rindex) => {
    SetFSQLParams({ Row: Row, Rowindex: Rindex });
    const SelectRow = {
      SIndex: Rindex,
      CPage: CurrentPage,
    };
    localStorage.setItem("Rowindex", JSON.stringify(SelectRow));
    dispatch(FQData({ FQDetails: Row }));
    navigate("/QBAdmin/QuestionBank/Remidation", {
      state: { Tab: location.state?.Tab },
    });
  };

  const ClearAllSTates = () => {
    SetFiltersList();
    SetFilterScenarioList();
    SetFilterQuestionList(); /*SetSelectedRow();*/
    SetNSBased("1");
    SetINBFQList();
    SetFSQLParams({ Row: "", Rowindex: "" });
    localStorage.removeItem("Rowindex");
    localStorage.removeItem("FSelected");
    ChapterRef.current.resetSelectedValues();
    GradeRef.current.resetSelectedValues();
    StatusRef.current.resetSelectedValues();
    SetFilters({
      Topic: [],
      SubTopic: [],
      LOC: [],
      SubLOC: [],
      Chapter: [],
      Grade: [],
      Status: [],
      COState: 0,
    });
    SetPreSelectedFilters({
      Topic: "Reset",
      SubTopic: [],
      LOC: [],
      SubLOC: [],
      Chapter: [],
      Grade: [],
      Status: [],
    });
    SetFiltersList();
    SetChapterOptions([]);
    SetGradeOptions([]);
    SetQLevel("");
    SetBTaxonomy();
    //  SetCOState("");
  };
  useMemo(() => {
    // if (!JSON.parse(localStorage.getItem("Rowindex"))?.CPage) {
    if (CurrentPage != JSON.parse(localStorage.getItem("Rowindex"))?.CPage) {
      SetFSQLParams({ Row: "", Rowindex: "" });
      localStorage.removeItem("Rowindex");
      SetFilterScenarioList();
      SetFilterQuestionList();
    }
    // }, [CurrentPage,PNumber]);
  }, [CurrentPage]);
  const HandleSNS = (e) => {
    SetFiltersList();
    SetFilterScenarioList();
    SetFilterQuestionList();
    SetNSBased(e);
    localStorage.setItem("FINQSNS", e);
  };

  return (
    <>

      {props.TType === "INQ" && (
        <div className="dflex JCCenter" style={{ gap: "15px" }}>
          {["1", "2"].map((Item) => (
            <div
              key={Item}
              className="dflex alignitems"
              style={{ gap: "5px" }}
            >
              <input
                type="Radio"
                value={Item}
                name="NONSCENario"
                checked={NSBased === Item}
                onChange={(e) => HandleSNS(e.target.value)}
              />
              {Item === "1" ? "Scenario Based" : "Non Scenario Based"}
            </div>
          ))}
        </div>
      )}

      <div className=" Card container-fluid mt-2 mb-2">
        <Row>
          <Col>
            <DDTopic
              className="NCLDropdown"
              SubjectId={items?.subjectId}
              onChange={(e, r) => StoreFilters(e, r, "Topic")}
              StoreOptions={(e) => StoreStartValue(e)}
              Selected={
                JSON.parse(localStorage.getItem("FSelected"))?.Filters
                  ?.Topic
              }
              Preselected={Filters?.Topic?.length}
            />{" "}
          </Col>
          <Col>
            <DDSubTopic
              className="NCLDropdown"
              Pid={Filters?.Topic?.join(",")}
              onChange={(e, r) => StoreFilters(e, r, "SubTopic")}
              clear={(Name) => CLearvalueremove(Name)}
              Preselected={
                JSON.parse(localStorage.getItem("FSelected"))?.Filters
                  ?.SubTopic
              }
            />{" "}
          </Col>
          <Col>
            {" "}
            <DDLearningOC
              className="NCLDropdown"
              Pid={Filters?.SubTopic?.join(",")}
              onChange={(e, r) => StoreFilters(e, r, "LOC")}
              clear={(Name) => CLearvalueremove(Name)}
              Preselected={
                JSON.parse(localStorage.getItem("FSelected"))?.Filters?.LOC
              }
            />
          </Col>
          <Col>
            <DDSubLearningOC
              className="NCLDropdown"
              SubjectId={items?.subjectId}
              Pid={Filters?.LOC?.join(",")}
              onChange={(e, r) => StoreFilters(e, r, "SubLOC")}
                  /* Selected={(e) => CheckSelected(e, "SubLOC")}*/ Preselected={
                JSON.parse(localStorage.getItem("FSelected"))?.Filters
                  ?.SubLOC
              }
            />
          </Col>

          <Col>
            {" "}
            <div className="DropdownHeaderNIMP">
              {" "}
              Chapter :
              <Multiselect
                onRemove={(e, r) => StoreFilters(e, r, "Chapter")}
                onSelect={(e, r) => StoreFilters(e, r, "Chapter")}
                style={{ searchBox: { minHeight: "15vh" } }}
                displayValue="name"
                placeholder=""
                options={ChapterOptions}
                ref={ChapterRef}
                showCheckbox
                avoidHighlightFirstOption="true"
                selectedValues={PreSelectedFilters?.Chapter}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="DropdownHeaderNIMP">
              {" "}
              Grade :
              <Multiselect
                onRemove={(e, r) => StoreFilters(e, r, "Grade")}
                onSelect={(e, r) => StoreFilters(e, r, "Grade")}
                style={{ searchBox: { minHeight: "15vh" } }}
                displayValue="name"
                placeholder=""
                options={GradeOptions}
                ref={GradeRef}
                showCheckbox
                avoidHighlightFirstOption="true"
                selectedValues={PreSelectedFilters?.Grade}
              />
            </div>
          </Col>
          <Col>
            <div className="DropdownHeaderNIMP">
              {" "}
              Status :
              <Multiselect
                onRemove={(e, r) => StoreFilters(e, r, "Status")}
                onSelect={(e, r) => StoreFilters(e, r, "Status")}
                style={{ searchBox: { minHeight: "15vh" } }}
                isObject={false}
                placeholder=""
                showCheckbox
                ref={StatusRef}
                options={["Used", "Unused", "Mapped", "Unmapped", "NA"]}
                selectedValues={Filters?.Status}
                avoidHighlightFirstOption="true"
              /*disablePreSelectedValues="true"*/
              />
            </div>
          </Col>
          <Col>
            <QuestionLevel
              className="NCLDropdown w-100"
              SubjectId={items?.subjectId}
              StoreValue={SetQLevel}
              SOption={QLevel}
              LovCategoryId={1}
              LID={SelectLanguage}
              onChange={(e) => SetQLevel(e.length > 1 ? "" : e)}
              Displayname="Select Question Level"
              labelname={
                <div className="DropdownHeader">Question Level :</div>
              }
            />
          </Col>
          <Col>
            {" "}
            <BloomTaxonomy
              className="NCLDropdown w-100"
              SubjectId={items?.subjectId}
              PId={QLevel}
              LID={SelectLanguage}
              StoreValue={SetBTaxonomy}
              LovCategoryId={42}
              SOption={BTaxonomy}
              onChange={(e) => SetBTaxonomy(e)}
              labelname={
                <div className="DropdownHeader">Bloom's Taxonomy :</div>
              }
            />
          </Col>
          <Col>
            {" "}
            <DropdownValues
              className="NCLDropdown w-100"
              options={CODropdown}
              // Displayname="Select"
              selectoption={Filters?.COState}
              onChange={(e) =>
                SetFilters({
                  ...Filters,
                  COState:
                    e.target.value === "Select" ? "" : e.target.value,
                })
              }
              labelname={
                <div className="DropdownHeader">Cloned/Original :</div>
              }
            />
          </Col>
        </Row>
        <div className="dflex gap-3 mt-2">
          <button
            className="Buttons CancleButton"
            onClick={() => ClearAllSTates()}
          >
            Clear
          </button>
          <button
            className="Buttons "
            onClick={() => {
              GetFiltersList();
              SetFSQLParams();
            }}
          >
            Go
          </button>
        </div>
      </div>

      {FiltersList && (
        <div className="Card" ref={ScrollRef}>
          {" "}
          <DataTable
            data={FiltersList}
            Selected={parseInt(FSQLParams?.Rowindex)}
            columns={FiltersListColumns}
            className="NCLDataTable"
            Dropdownvalues={["10", "25", "50", "100"]}
            ShowPagination="true"
            ShowPagecount="true"
            GetCurrentPage={SetCurrentPage}
            Selectedpage={
              JSON.parse(localStorage.getItem("Rowindex"))?.CPage
            }
          />{" "}
        </div>
      )}

      <div>
        {(FilterScenarioList || FilterQuestionList) && (
          <div className="dflex alignitems mt-4">
            {items?.subjectName} &gt;{FQuestionDetails.topicName} &gt; {FQuestionDetails.subTopicName}{" "}
            &gt; <b className="text-success"> {FQuestionDetails.loName}</b>
          </div>
        )}
        {FilterScenarioList && <Scenario data={FilterScenarioList} />}

        {FilterQuestionList && (
          <DirectQuestions
            data={FilterQuestionList}
            Filtersfunction={() =>
              FQList(FSQLParams?.Row, FSQLParams?.Rowindex)
            }
          />
        )}

        {INBFQList && (
          <InputBasedQuestions
            data={INBFQList}
            SType={NSBased === "1" ? "SCDISQ" : "NONSCDISQ"}
          />
        )}
      </div>
      {Load && <Loading />}
    </>
  );
});
export default QBLOFilters;
